export const volumes = [
  {
    title: 'VOLUMEN 1 — Principios para Recuperar el Vínculo Después del Conflicto™',
    items: [
      'Ordená qué pasó realmente sin mezclar hechos con interpretaciones',
      'Ordená lo que sentís y pensás antes de acercarte',
      'Sabé qué tenés que retomar y qué podés dejar',
      'Prepará tu próximo acercamiento con pasos concretos',
      'Evitá actuar desde el impulso, la culpa o el agotamiento',
    ],
    border: 'border-blue-400/30',
  },
  {
    title: 'VOLUMEN 2 — Método para Retomar el Diálogo Después del Conflicto™',
    items: [
      'Sabés cómo abrir la conversación sin volver a reabrir la pelea',
      'Expresás lo que necesitás sin acusar ni reprochar',
      'Escuchás sin quedar atrapada en la defensa',
      'Reconocés cuándo pausar antes de que todo vuelva a escalar',
      'Sabés cómo cerrar o pausar una conversación cuando necesitás hacerlo',
    ],
    border: 'border-green-400/30',
  },
  {
    title:
      'VOLUMEN 3 — Estrategias para Reconstruir la Comunicación Después de una Discusión™',
    items: [
      'Revisás lo ocurrido para aprender sin castigarte',
      'Identificás patrones de conflicto que se repiten',
      'Transformás la crisis en aprendizaje práctico',
      'Preparás formas diferentes de abordar situaciones similares',
      'Registrás avances sin convertir el cuidado en obsesión',
    ],
    border: 'border-amber-400/30',
  },
];

export const kitIncludes = [
  'Hoja de ruta de 14 días paso a paso',
  'Frases listas para el primer acercamiento',
  'Herramienta visual para elegir el momento de hablar',
  'Checklist del reencuentro imprimible',
];

export const bonuses = [
  {
    number: '01',
    title: 'Mapa de Reencuentro en 10 Minutos™',
    detail:
      'Hoja de ruta rápida para ordenar lo ocurrido y preparar tu primer acercamiento sin actuar desde el pánico.',
    value: '$12.000',
  },
  {
    number: '02',
    title: 'Tarjetas de Primer Acercamiento™',
    detail:
      'Banco de 45 frases listas para adaptar según tu vínculo (padre, madre, esposo) y romper el hielo sin volver a pelear.',
    value: '$10.000',
  },
  {
    number: '03',
    title: 'Semáforo de Tensión Post-Discusión™',
    detail:
      'Herramienta visual para detectar si es buen momento de hablar, esperar o pausar según el contexto y tu estado emocional.',
    value: '$9.000',
  },
  {
    number: '04',
    title: 'Traductor de Reproches a Pedidos Claros™',
    detail:
      'Guía práctica para convertir quejas impulsivas en necesidades concretas y expresarlas con mayor claridad.',
    value: '$11.000',
  },
  {
    number: '05',
    title: 'Checklist del Reencuentro™',
    detail:
      'Herramienta práctica para revisar cómo estás afrontando el reencuentro antes, durante y después de una discusión.',
    value: '$10.000',
  },
];

export const painPoints = [
  'Quedás distante de tu familiar después de una discusión y no sabés cómo volver a acercarte.',
  'Tenés miedo de volver a hablar porque pensás que la conversación puede terminar otra vez en conflicto.',
  'No sabés qué decir para romper el hielo después de lo que pasó.',
  'Sentís que cada discusión queda dando vueltas y no sabés cómo aprender de lo ocurrido para la próxima vez.',
  'Cuando finalmente intentás acercarte, improvisás y salís peor.',
];

export const costs = [
  'Quedarte sin saber cómo volver a hablar después de una discusión.',
  'Evitar un tema porque temés que vuelva a generar tensión.',
  'Acercarte improvisando y no saber qué decir.',
  'Terminar acumulando distancia después de cada conflicto.',
  'Volver a atravesar la misma situación sin aprender qué podrías hacer diferente.',
];

export const faqs = [
  {
    question: '¿Este protocolo reemplaza el tratamiento médico?',
    answer:
      'No. Es una herramienta educativa y comunicacional. No reemplaza la atención ni las indicaciones de profesionales de la salud.',
  },
  {
    question: '¿Cuánto tiempo me toma aplicarlo?',
    answer:
      'Podés recorrer el protocolo a tu ritmo y usar las herramientas cuando aparezcan situaciones concretas de comunicación.',
  },
  {
    question: '¿Qué pasa si mi familiar no quiere hablar?',
    answer:
      'El protocolo te prepara a vos para el acercamiento. Tu familiar decide cómo responder.',
  },
  {
    question: '¿Es 100% digital?',
    answer:
      'Sí. Recibís el PDF por email y podés usarlo desde celular, tablet o computadora.',
  },
  {
    question: '¿Cuál es la diferencia con otros cursos?',
    answer:
      'Este protocolo se enfoca específicamente en cómo volver a acercarte después de una discusión durante el cuidado.',
  },
];
